/**
 * Turns a scraped movie payload into the shape the Add Movie wizard
 * keeps in redux.
 *
 * Lifted out of the getMediaData endpoint unchanged so the queued flow
 * can reuse it: a queued scrape produces exactly the same payload, just
 * read back from a finished job later instead of awaited on the spot,
 * and it has to land in redux identically or every step after it would
 * need to know which flow it came from.
 *
 * `referenceData` is the dropdown lists that arrive alongside the
 * scrape (studios, ratings, genres and friends).
 */
export const buildMovieData = (
  scrapedMovieData: any,
  referenceData: any,
) => {
  const generalMovieData = {
    title: scrapedMovieData.title,
    originalTitle: scrapedMovieData.originalTitle,
    itunesTitle: scrapedMovieData.itunesTitle,
    shortDescription: scrapedMovieData.shortDescription,
    description: scrapedMovieData.description,
    releaseDate: scrapedMovieData.releaseDate,
    studio: scrapedMovieData.studio,
    rating: scrapedMovieData.rating,
    copyright: scrapedMovieData.copyright,
    quality: scrapedMovieData.quality,
    format: scrapedMovieData.format,
    source: scrapedMovieData.source,
    sourceLink: scrapedMovieData.sourceLink,
    itunesId: scrapedMovieData.itunesId,
    imdbId: scrapedMovieData.imdbId,
    imdbRating: scrapedMovieData.imdbRating,
    trailerUrl: scrapedMovieData.trailerUrl,
  };

  const genreData = scrapedMovieData.genres.map((genreItem: any) => {
    return {
      genre: {
        id: genreItem.id,
        label: genreItem.label,
      },
      main: genreItem.main,
    };
  });

  const countryData = scrapedMovieData.countries.map((countryItem: any) => {
    return {
      country: {
        id: countryItem.id,
        label: countryItem.label,
      },
      main: countryItem.main,
    };
  });

  const secondaryMovieData = {
    genres: genreData,
    countries: countryData,
    tags: scrapedMovieData.tags,
    collections: scrapedMovieData.collections,
  };

  const castCrewMovieData = {
    cast: scrapedMovieData.cast,
    directors: scrapedMovieData.directors,
    producers: scrapedMovieData.producers,
    screenwriters: scrapedMovieData.screenwriters,
  };

  const languageData = scrapedMovieData.languages.map((languageItem: any) => {
    return {
      language: {
        id: languageItem.id,
        label: languageItem.label,
      },
      main: languageItem.main,
      audioTrack: false,
      subtitle: false,
    };
  });

  const languagesMovieData = {
    languages: languageData,
  };

  return {
    generalMovieData: generalMovieData,
    secondaryMovieData: secondaryMovieData,
    castCrewMovieData: castCrewMovieData,
    languagesMovieData: languagesMovieData,
    studios: referenceData.studios,
    ratings: referenceData.ratings,
    qualities: referenceData.qualities,
    formats: referenceData.formats,
    sources: referenceData.sources,

    genres: referenceData.genres,
    countries: referenceData.countries,
    tags: referenceData.tags,
    collections: referenceData.collections,

    languages: referenceData.languages,

    accessLevels: referenceData.accessLevels,
  };
};
